import {
    Box, Typography, Grid, Divider, Paper
} from "@mui/material";

const SalarySlip = ({ data }) => {

    const totalEarnings = data.earnings?.reduce((s, e) => s + e.amount, 0);
    const totalDeductions = data.deductions?.reduce((s, d) => s + d.amount, 0);
    const netSalary = totalEarnings - totalDeductions;

    const toCamelCase = (str) => {
        return str
            ?.toLowerCase()
            .replace(/[^a-zA-Z0-9 ]/g, '')
            .split(' ')
            .map((word, index) =>
                index === 0
                    ? word.charAt(0).toUpperCase() + word.slice(1)
                    : word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(' ');
    };

    if (!data) return null;

    return (
        <Paper sx={{ px: 6, py: 2, maxWidth: 900, mx: "auto" }}>
            {/* COMPANY HEADER */}
            <Box textAlign="center">
                <Typography variant="h5" fontWeight="bold">
                    {toCamelCase(data.schoolName)}
                </Typography>
                <Typography variant="body2">
                    {toCamelCase([data?.addressDTO?.addressLine1, data?.addressDTO?.city, data?.addressDTO?.postalCode, data?.addressDTO?.state].join(", "))}
                </Typography>
                <Typography variant="body2">Phone: {data?.contactPhone} </Typography>
                <Divider sx={{ my: 2 }} />
            </Box>

            <Typography variant="h6" align="center" fontWeight="bold">
                Salary Slip – {data.month} {data.year}
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* EMPLOYEE DETAILS */}
            <Grid container spacing={2} justifyContent={'space-between'}>
                <Grid item xs={6}>
                    <Typography><b>Name:</b> {data.employeeName}</Typography>
                    <Typography><b>Employee ID:</b> {data.employeeId}</Typography>
                    <Typography><b>Designation:</b> {data.designation}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography><b>Department:</b> {data.department}</Typography>
                    <Typography><b>Bank:</b> {data.bank}</Typography>
                    <Typography><b>Account No:</b> {data.accountNo}</Typography>
                </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            {/* SALARY BREAKUP */}
            <Grid container spacing={2} justifyContent={'space-between'}>
                <Grid item xs={6}>
                    <Typography fontWeight="bold">Earnings</Typography>
                    {data?.earnings?.map((e, i) => (
                        <Row key={i} label={e.label} value={e.amount} />
                    ))}
                    <Divider />
                    <Row bold label="Total Earnings" value={totalEarnings?.toFixed(2)} />
                </Grid>

                <Grid item xs={6}>
                    <Typography fontWeight="bold">Deductions</Typography>
                    {data?.deductions?.map((d, i) => (
                        <Row key={i} label={d.label} value={d.amount} />
                    ))}
                    <Divider />
                    <Row bold label="Total Deductions" value={totalDeductions?.toFixed(2)} />
                </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Box
                display="flex"
                justifyContent="space-between"
                bgcolor="#f4f4f4"
                p={2}
                borderRadius={1}
            >
                <Typography variant="h6" fontWeight="bold">
                    Net Salary
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                    ₹ {netSalary?.toFixed(2)}
                </Typography>
            </Box>

            <Typography variant="caption" align="center" display="block" mt={2}>
                This is a system generated salary slip. Signature not required.
            </Typography>
        </Paper>
    );
};

const Row = ({ label, value, bold }) => (
    <Box display="flex" justifyContent="space-between" my={0.5}>
        <Typography fontWeight={bold ? "bold" : "normal"}>{label}</Typography>
        <Typography fontWeight={bold ? "bold" : "normal"}>₹ {value}</Typography>
    </Box>
);

export default SalarySlip;
